(function (factory) {
    typeof define === 'function' && define.amd ? define(['kendo.core'], factory) :
    factory();
})((function () {
    (function( window, undefined$1 ) {
        kendo.cultures["sr-Cyrl"] = {
            name: "sr-Cyrl",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": ".",
                ".": ",",
                groupSize: [3],
                percent: {
                    pattern: ["-n%","n%"],
                    decimals: 2,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "%"
                },
                currency: {
                    name: "",
                    abbr: "",
                    pattern: ["-n $","n $"],
                    decimals: 2,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "дин."
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["недеља","понедељак","уторак","среда","четвртак","петак","субота"],
                        namesAbbr: ["нед.","пон.","ут.","ср.","чет.","пет.","суб."],
                        namesShort: ["не","по","ут","ср","че","пе","су"]
                    },
                    months: {
                        names: ["јануар","фебруар","март","април","мај","јун","јул","август","септембар","октобар","новембар","децембар"],
                        namesAbbr: ["јан.","феб.","март","апр.","мај","јун","јул","авг.","септ.","окт.","нов.","дец."]
                    },
                    AM: [""],
                    PM: [""],
                    patterns: {
                        d: "dd.MM.yyyy.",
                        D: "d. MMMM yyyy.",
                        F: "d. MMMM yyyy. H:mm:ss",
                        g: "dd.MM.yyyy. H:mm",
                        G: "dd.MM.yyyy. H:mm:ss",
                        m: "d. MMMM",
                        M: "d. MMMM",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "H:mm",
                        T: "H:mm:ss",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "MMMM yyyy.",
                        Y: "MMMM yyyy."
                    },
                    "/": ".",
                    ":": ":",
                    firstDay: 1
                }
            }
        };
    })();

}));
